export * from './C60.partner.page'
